module.exports = __webpack_public_path__ + "img/13.4e37b6c6.svg";